import { ESPECIALIDADE_LABEL, type EspecialidadeProf } from "../../types";
import { DISCIPLINA_CLASSE, ESPECIALIDADE_CURTA } from "../types";

/**
 * Chip da disciplina — cor por especialidade (nutri = ardósia, nunca vermelho).
 * Codifica por cor + rótulo. Reusa a base .badge do app + classes .disc-*.
 */
export function EspecialidadeBadge({
  especialidade,
  curto = false,
}: {
  especialidade: EspecialidadeProf;
  curto?: boolean;
}) {
  const label = curto ? ESPECIALIDADE_CURTA[especialidade] : ESPECIALIDADE_LABEL[especialidade];
  return (
    <span className={`badge disc ${DISCIPLINA_CLASSE[especialidade]}`}>
      <span className="disc-dot" aria-hidden />
      {label}
    </span>
  );
}
